import { Routes, Route, useLocation } from 'react-router-dom';
import { usePageTracking } from "./tracking";

import 'semantic-ui-css/semantic.min.css'

// Main
import Main from "./Main/Main"

// System
import ListSystems from "./System/ListSystems"

// Call
import Calls from "./Call/Calls"

import AboutComponent from "./About/AboutComponent"
import PrivacyComponent from "./Privacy/PrivacyComponent"

// Event
import ListEvents from "./Event/ListEvents"
import ViewEvent from "./Event/ViewEvent"
import ActivityChart from './Call/BetterActivityChart';

const RedirectToNewDomain = () => {
  const location = useLocation();
  // Redirect to new domain with query parameters
  window.location.href = `https://original.scannerlivestream.com/${location.search}`;
  return null; // Component renders nothing
};

const App = () => {
  usePageTracking();

  return (
    <Routes>
      <Route exact path="/" element={<Main />} />
      <Route exact path="/systems" element={<ListSystems />} />
      <Route exact path="/system/:shortName" element={<Calls />} />
      <Route exact path="/calls" element={<RedirectToNewDomain />} />
      <Route exact path="/events" element={<ListEvents />} />
      <Route exact path="/events/:id" element={<ViewEvent />} />
      <Route exact path="/about" element={<AboutComponent />} />
      <Route exact path="/test" element={<ActivityChart />} />
      <Route exact path="/privacy" element={<PrivacyComponent />} />
    </Routes>
  );
};

export default App;
